import Channel from "@repo/utils/Channel";

namespace Devtools {
  export const key = "@repo/devtools/Devtools" as const;
  export const targets = ["page", "ext"] as const;
  export type Target = (typeof targets)[number];
  export const message = <const T>(target: Target, data: T) =>
    [key, target, data] as const;
  export type Message = ReturnType<typeof message>;
  export namespace Message {
    export const accept = (
      message: any,
      target: Target | "*"
    ): message is Message =>
      message?.[0] === key &&
      (target === "*" ? targets.includes(message[1]) : message[1] === target);
  }

  export const channel = new Channel<{
    send: [["setFeatureStore", [feature: string, path: any[], value: any]]];
    receive: [["init", undefined]];
  }>({
    send(...args) {
      window.postMessage(
        message("ext", structuredClone(args)),
        window.location.origin
      );
    },
    receive(receive) {
      window.addEventListener("message", (event) => {
        if (Message.accept(event.data, "page")) {
          // @ts-expect-error
          receive(...event.data[2]);
        }
      });
    },
  });

  export function setFeatureStore(feature: string, path: any[], value: any) {
    channel.send("setFeatureStore", [feature, path, value]);
  }

  export function on(event: "init", callback: () => void) {
    channel.receive(event, callback);
  }
}

export default Devtools;
